<template>
  <div class="account-auth-form-content">
    <div class="old-mb-4">
      <ValidationProvider
        name="email"
        rules="required|email"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          id="RecoverEmail"
          name="email"
          type="email"
          v-model="email"
          :required="true"
          label="Email"
          :error="errors && errors[0]"
        />
      </ValidationProvider>
    </div>

    <input class="submit-button plaid-l fs-12" type="submit" value="SUBMIT" />

    <div class="account-auth-contact-us" @click="showLoginForm">Cancel</div>
  </div>
</template>

<script>
export default {
  name: "recover-password-form",
  data() {
    return {
      email: "",
    };
  },
  methods: {
    showLoginForm() {
      const loginContainer = document.querySelector(".account-auth-login");
      const recoverPasswordContainer = document.querySelector(
        ".account-auth-recover-password"
      );

      recoverPasswordContainer.style.display = "none";
      loginContainer.style.display = "block";
    },
  },
};
</script>
